/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { Version } from '@angular/core';
/**
 * @stable
 */
export var /** @type {?} */ VERSION = new Version('2.4.10');
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/compiler/src/version.js
// module id = 669
// module chunks = 3